import Vue from 'vue'

export default {
    setEventData(state, { eventData, eventId}) {
        Vue.set(state.event, eventId, eventData)
    },
    startLoadingEvent(state, eventId) {
        Vue.set(state.loading, eventId, true)
    },
    finishLoadingEvent(state, eventId) {
        Vue.set(state.loading, eventId, false)
    }
}
